'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _parts = require('./parts.service');

var _parts2 = _interopRequireDefault(_parts);

var _partsDataprovider = require('./parts.dataprovider.service');

var _partsDataprovider2 = _interopRequireDefault(_partsDataprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('product-parts', []).service('ProductPartsService', _parts2.default).service('ProductPartsDataProvider', _partsDataprovider2.default).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-parts/index.js
 **/